import { render, staticRenderFns } from "./QtDetailHandleList.vue?vue&type=template&id=22007bce&scoped=true&"
import script from "./QtDetailHandleList.vue?vue&type=script&lang=js&"
export * from "./QtDetailHandleList.vue?vue&type=script&lang=js&"
import style0 from "./QtDetailHandleList.vue?vue&type=style&index=0&id=22007bce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22007bce",
  null
  
)

export default component.exports